import { type CSSObject } from '@emotion/react'
import { propertyMap } from './property-map'
import { type RuleSets, type RuleTest } from './types'

export type { RuleSets }

const defaultTest: RuleTest = 'inset-inline-end: 0'
export function modernWithFallback(
  rulesets: RuleSets,
  test: RuleTest = defaultTest
): CSSObject {
  let preferred: CSSObject = {}
  let fallback: CSSObject = {}

  rulesets.forEach((ruleset) => {
    let preferredRules: CSSObject
    let fallbackRules: CSSObject = {}

    if (Array.isArray(ruleset)) {
      ;[preferredRules, fallbackRules] = ruleset
    } else {
      preferredRules = ruleset
      fallbackRules = Object.entries(preferredRules).reduce(
        (memo, [property, value]) => {
          const fallbackProperty = propertyMap.get(property)
          if (!fallbackProperty) return memo

          if (Array.isArray(fallbackProperty)) {
            const fallbackProperties = fallbackProperty.reduce(
              (innerMemo, property) => ({
                ...innerMemo,
                [property]: value,
              }),
              {}
            )
            return Object.assign(memo, fallbackProperties)
          }

          return {
            ...memo,
            [fallbackProperty]: value,
          }
        },
        {}
      )
    }

    preferred = {
      ...preferred,
      ...preferredRules,
    }

    if (fallbackRules && Object.keys(fallbackRules).length > 0) {
      fallback = {
        ...fallback,
        ...fallbackRules,
      }
    }
  })

  if (Object.keys(fallback).length === 0) {
    return preferred
  }

  return {
    ...preferred,
    [`@supports not (${test || defaultTest})`]: {
      ...fallback,
    },
  }
}
